export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const GET_ASSIGNED_PERMISSIONS_FOR_CURRENT_USER =
  'GET_ASSIGNED_PERMISSIONS_FOR_CURRENT_USER';

export const GET_PURCHASE_ORDERS = 'GET_PURCHASE_ORDERS';
export const GET_PURCHASE_ORDERS_AND_LINE_ITEM_DATA =
  'GET_PURCHASE_ORDERS_AND_LINE_ITEM_DATA';
export const CREATE_VEHICLE_TRACKING = 'CREATE_VEHICLE_TRACKING';

export const API_FAILED = 'API_FAILED';
export const CLEAR_API_ERROR = 'CLEAR_API_ERROR';

export const GET_VEHICLE_TRAKING_REPORT_DATA =
  'GET_VEHICLE_TRAKING_REPORT_DATA';
export const GET_TARGET_VS_ACTUAL_FOR_CONFIG =
  'GET_TARGET_VS_ACTUAL_FOR_CONFIG';
export const GET_TIMELINE = 'GET_TIMELINE';
export const GET_WORKFLOW_STAGES_DATA_FOR_UPCOMING_STAGE_REQUEST =
  'GET_WORKFLOW_STAGES_DATA_FOR_UPCOMING_STAGE_REQUEST';
export const GET_UPCOMING_WORKFLOW_STAGE_REQUEST =
  'GET_UPCOMING_WORKFLOW_STAGE_REQUEST';
export const GET_PO_LIST = 'GET_PO_LIST';
export const GET_PO_ITEMS = 'GET_PO_ITEMS';
export const SKIP_STAGE = 'SKIP_STAGE';
export const MOVE_TO_NEXT_STAGE = 'MOVE_TO_NEXT_STAGE';
export const CREATE_UPCOMING_WORKFLOW_STAGE_REQUEST =
  'CREATE_UPCOMING_WORKFLOW_STAGE_REQUEST';
export const GET_STAGE_DATA = 'GET_STAGE_DATA';
export const GET_VEHICLE_LIST = 'GET_VEHICLE_LIST';

export const TENANT_LIST = 'TENANT_LIST';
export const CREATE_TENANT = 'CREATE_TENANT';
export const STAGES_LIST = 'STAGES_LIST';
export const CREATE_STAGE = 'CREATE_STAGES';
export const CREATE_ORGANISATION = 'CREATE_ORGANISATION';
export const ORGANISATION_LIST = 'ORGANISATION_LIST';
export const ASSIGN_STAGE = 'ASSIGN_STAGE';
export const ALL_USERS = 'ALL_USERS';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const CREATE_USER = 'CREATE_USER';
export const GET_VEHICLE_TRACKING_DETAILS = 'GET_VEHICLE_TRACKING_DETAILS';
export const RESET_VEHICLE_TRACKING_DETAILS = 'RESET_VEHICLE_TRACKING_DETAILS';
export const GET_BARCODE = 'GET_BARCODE';
export const GET_BUSINESS_PARTNER_WITH_OPEN_PO_DROPDOWN_OPTIONS =
  'GET_BUSINESS_PARTNER_WITH_OPEN_PO_DROPDOWN_OPTIONS';
export const GET_ASSIGNED_STAGES = 'GET_ASSIGNED_STAGES';
export const GET_WORKFLOWS = 'GET_WORKFLOWS';
export const GET_WORKFLOW_STAGES_FOR_VEHICLE_TRACKING =
  'GET_WORKFLOW_STAGES_FOR_VEHICLE_TRACKING';
export const CLEAR_WORKFLOW_STAGES_FOR_VEHICLE_TRACKING =
  'CLEAR_WORKFLOW_STAGES_FOR_VEHICLE_TRACKING';
export const CLEAR_STAGE_DATA = 'CLEAR_STAGE_DATA';
export const GET_TARGET_VS_ACTUAL_CONFIG_FOR_WORKFLOW_STAGE =
  'GET_TARGET_VS_ACTUAL_CONFIG_FOR_WORKFLOW_STAGE';
export const CREATE_TARGET_VS_ACTUAL_LOGS = 'CREATE_TARGET_VS_ACTUAL_LOGS';
export const GET_VEHICLE_TRACKING_REPORT_LIST =
  'GET_VEHICLE_TRACKING_REPORT_LIST';
export const GET_VEHICLE_TRACKING_LIST = 'GET_VEHICLE_TRACKING_LIST';
export const GET_NEXT_AVAILABLE_WORKFLOW_STAGES =
  'GET_NEXT_AVAILABLE_WORKFLOW_STAGES';
export const SKIP_AND_MOVE_VT_TO_ANOTHER_WS = 'SKIP_AND_MOVE_VT_TO_ANOTHER_WS';
export const GET_VARIANCE_REPORT_DATA_V2 = 'GET_VARIANCE_REPORT_DATA_V2';
export const GET_INWARD_REPORT = 'GET_INWARD_REPORT';
export const GET_INWARD_REPORT_WITH_EXIT_TIME =
  'GET_INWARD_REPORT_WITH_EXIT_TIME';
export const GET_AVAILABLE_MATERIAL_CODES = 'GET_AVAILABLE_MATERIAL_CODES';
export const CAPTURE_VEHICLE_WEIGHT = 'CAPTURE_VEHICLE_WEIGHT';
export const GET_CAMERA_WEIGHT_REPORT_DATA = 'GET_CAMERA_WEIGHT_REPORT_DATA';
export const GET_WEIGH_BRIDGE_WORK_CENTERS = 'GET_WEIGH_BRIDGE_WORK_CENTERS';
export const GET_PACK_TYPE = 'GET_PACK_TYPE';
export const GET_PACK_TYPE_FOR_PURCHASE_ORDER_LINE_ITEM =
  'GET_PACK_TYPE_FOR_PURCHASE_ORDER_LINE_ITEM';
export const CREATE_VEHICLE_TRACKING_LINE_ITEM =
  'CREATE_VEHICLE_TRACKING_LINE_ITEM';
export const UPDATE_VEHICLE_TRACKING_LINE_ITEM =
  'UPDATE_VEHICLE_TRACKING_LINE_ITEM';
export const GET_PURCHASE_ORDER_LINE_ITEMS = 'GET_PURCHASE_ORDER_LINE_ITEMS';
export const GET_VEHICLE_TRACKING_LINE_ITEM = 'GET_VEHICLE_TRACKING_LINE_ITEM';
export const GET_STORAGE_LOCATIONS_GROUPED_BY_PLANT =
  'GET_STORAGE_LOCATIONS_GROUPED_BY_PLANT';
export const CREATE_GRN_FOR_VEHICLE_TRACKING =
  'CREATE_GRN_FOR_VEHICLE_TRACKING';
export const SETTINGS_ICON_ACTIVE_TOGGLE = 'SETTINGS_ICON_ACTIVE_TOGGLE';
export const GET_VEHICLE_TRACKING_AWAITING_GRN =
  'GET_VEHICLE_TRACKING_AWAITING_GRN';
export const GET_GRN_FOR_VEHICLE_TRACKING = 'GET_GRN_FOR_VEHICLE_TRACKING';
export const UPDATE_GRN_FOR_VEHICLE_TRACKING =
  'UPDATE_GRN_FOR_VEHICLE_TRACKING';
export const UPDATE_FIELD_FOR_VEHICLE_TRACKING =
  'UPDATE_FIELD_FOR_VEHICLE_TRACKING';
export const GET_TARGET_VS_ACTUAL_LOGS = 'GET_TARGET_VS_ACTUAL_LOGS';
export const GET_TARE_WEIGHT_HISTORY_FOR_VEHICLE_NUMBER =
  'GET_TARE_WEIGHT_HISTORY_FOR_VEHICLE_NUMBER';
export const GET_WORKFLOW_STAGES_FOR_WORKFLOW =
  'GET_WORKFLOW_STAGES_FOR_WORKFLOW';
export const GET_WORKFLOW_STAGES_FOR_CURRENT_USER =
  'GET_WORKFLOW_STAGES_FOR_CURRENT_USER';
export const RESET_PRINT_DETAILS = 'RESET_PRINT_DETAILS';
export const GET_BUSINESS_PARTNER_DROPDOWN_OPTIONS =
  'GET_BUSINESS_PARTNER_DROPDOWN_OPTIONS';
export const CREATE_DIMENSION = 'CREATE_DIMENSION';
export const GET_QUALITY_CHECK_LIST = 'GET_QUALITY_CHECK_LIST';
export const CREATE_VEHICLE_TRACKING_OUTWARD =
  'CREATE_VEHICLE_TRACKING_OUTWARD';
export const CREATE_DUPLICATE_VEHICLE_TRACKING =
  'CREATE_DUPLICATE_VEHICLE_TRACKING';
export const GET_DELIVERY_FOR_BUSINESS_PARTNER =
  'GET_DELIVERY_FOR_BUSINESS_PARTNER';
export const RESET_DELIVERY_FOR_BUSINESS_PARTNER =
  'RESET_DELIVERY_FOR_BUSINESS_PARTNER';
export const GET_DELIVERY_DROPDOWN_OPTIONS = 'GET_DELIVERY_DROPDOWN_OPTIONS';
export const RESET_DELIVERY_LIST_FOR_VEHICLE_NUMBER =
  'RESET_DELIVERY_LIST_FOR_VEHICLE_NUMBER';
export const RESET_VEHICLE_DROPDOWN_OPTIONS = 'RESET_VEHICLE_DROPDOWN_OPTIONS';
export const CREATE_QUALITY_CHECK = 'CREATE_QUALITY_CHECK';
export const UPDATE_QUALITY_CHECK_PRODUCT_AND_DIMENSION =
  'UPDATE_QUALITY_CHECK_PRODUCT_AND_DIMENSION';
export const GET_QUALITY_CHECK_PRODUCT_AND_DIMENSION_DETAIL =
  'GET_QUALITY_CHECK_PRODUCT_AND_DIMENSION_DETAIL';
export const GET_VEHICLE_TRACKING_LIST_FOR_PLANNING =
  'GET_VEHICLE_TRACKING_LIST_FOR_PLANNING';
export const GET_OUTWARD_VEHICLE_TRACKING_DETAILS =
  'GET_OUTWARD_VEHICLE_TRACKING_DETAILS';
export const RESET_OUTWARD_VEHICLE_TRACKING_DETAILS =
  'RESET_OUTWARD_VEHICLE_TRACKING_DETAILS';
export const UPDATE_VEHICLE_TRACKING_FOR_OUTWARD =
  'UPDATE_VEHICLE_TRACKING_FOR_OUTWARD';
export const GET_PACK_TYPE_FOR_DELIVERY_LINE_ITEM =
  'GET_PACK_TYPE_FOR_DELIVERY_LINE_ITEM';
export const RESET_GET_PACK_TYPE_FOR_DELIVERY_LINE_ITEM =
  'RESET_GET_PACK_TYPE_FOR_DELIVERY_LINE_ITEM';
export const CREATE_VEHICLE_TRACKING_LOAD_HEADER =
  'CREATE_VEHICLE_TRACKING_LOAD_HEADER';
export const GET_VEHICLE_TRACKING_ATTACHED_LOADS =
  'GET_VEHICLE_TRACKING_ATTACHED_LOADS';
export const GET_LOAD_LINE_ITEMS_FOR_LOAD_HEADER =
  'GET_LOAD_LINE_ITEMS_FOR_LOAD_HEADER';
export const UPDATE_VEHICLE_TRACKING_LOAD_LINE_ITEM =
  'UPDATE_VEHICLE_TRACKING_LOAD_LINE_ITEM';
export const UPDATE_VEHICLE_TRACKING_LOAD = 'UPDATE_VEHICLE_TRACKING_LOAD';
export const GET_DATA_FOR_VEHICLE_TRACKING_LOAD_CARDS =
  'GET_DATA_FOR_VEHICLE_TRACKING_LOAD_CARDS';
export const GET_CAPTURED_WEIGHT_FOR_WEIGHT_BRIDGE_EVENT_UUID =
  'GET_CAPTURED_WEIGHT_FOR_WEIGHT_BRIDGE_EVENT_UUID';
export const UPDATE_VEHICLE_TRACKING_LOAD_WEIGHT =
  'UPDATE_VEHICLE_TRACKING_LOAD_WEIGHT';
export const CONFIRM_VEHICLE_TRACKING_LOAD = 'CONFIRM_VEHICLE_TRACKING_LOAD';
export const GET_LOAD_LINE_ITEMS_FOR_VEHICLE_TRACKING =
  'GET_LOAD_LINE_ITEMS_FOR_VEHICLE_TRACKING';
export const UPDATE_VEHICLE_TRACKING_ON_HOLD =
  'UPDATE_VEHICLE_TRACKING_ON_HOLD';
export const VALIDATE_AND_GET_DUPLICATE_OBJECTS_FOR_VEHICLE_TRACKING =
  'VALIDATE_AND_GET_DUPLICATE_OBJECTS_FOR_VEHICLE_TRACKING';
export const GET_VAHAN_01_DETAILS = 'GET_VAHAN_01_DETAILS';
export const CLEAR_VAHAN01_DETAILS = 'CLEAR_VAHAN01_DETAILS';
// settings
export const GET_PULL_EVENT_LOGS_LIST = 'GET_PULL_EVENT_LOGS_LIST';
export const GET_PUSH_EVENT_LOGS_LIST = 'GET_PUSH_EVENT_LOGS_LIST';
export const GET_PAGINATED_PRODUCTS = 'GET_PAGINATED_PRODUCTS';
export const GET_PRODUCT_OPTIONS = 'GET_PRODUCT_OPTIONS';
export const CREATE_PACK_TYPE_ASSIGNMENT = 'CREATE_PACK_TYPE_ASSIGNMENT';
export const GET_PRODUCT_PACK_TYPE_ASSIGNMENTS =
  'GET_PRODUCT_PACK_TYPE_ASSIGNMENTS';
export const GET_PROFILE_DETAILS = 'GET_PROFILE_DETAILS';
export const GET_DIMENSION_LIST = 'GET_DIMENSION_LIST';
export const GET_VEHICLE_DROPDOWN_OPTIONS = 'GET_VEHICLE_DROPDOWN_OPTIONS';
export const GET_CATEGORY_BASED_BUSINESS_PARTNER =
  'GET_CATEGORY_BASED_BUSINESS_PARTNER';
export const GET_TRANSPORTER_DATA = 'GET_TRANSPORTER_DATA';
export const GET_TRANSPORTER_DROPDOWN_OPTIONS =
  'GET_TRANSPORTER_DROPDOWN_OPTIONS';
export const GET_ATTACHED_DELIVERY_FOR_OUTWARD_VEHICLE =
  'GET_ATTACHED_DELIVERY_FOR_OUTWARD_VEHICLE';
export const RESET_ATTACHED_DELIVERY_FOR_OUTWARD_VEHICLE =
  'RESET_ATTACHED_DELIVERY_FOR_OUTWARD_VEHICLE';
export const GET_VEHICLE_DETAILS_FOR_OUTWARD =
  'GET_VEHICLE_DETAILS_FOR_OUTWARD';
export const GET_VEHICLE_TRACKINGS_FOR_VEHICLE_DETAIL =
  'GET_VEHICLE_TRACKINGS_FOR_VEHICLE_DETAIL';
export const RESET_VEHICLE_DETAILS = 'RESET_VEHICLE_DETAILS';
export const GET_VEHICLE_LOCATION_LOGS = 'GET_VEHICLE_LOCATION_LOGS';
export const CREATE_VEHICLE_LOCATION_LOGS = 'CREATE_VEHICLE_LOCATION_LOGS';
export const RESET_VEHICLE_LOCATION_LOGS = 'RESET_VEHICLE_LOCATION_LOGS';
export const CREATE_POD_ATTACHMENTS_FOR_VEHICLE_TRACKING =
  'CREATE_POD_ATTACHMENTS_FOR_VEHICLE_TRACKING';
export const GET_POD_ATTACHMENTS_FOR_VEHICLE_TRACKING =
  'GET_POD_ATTACHMENTS_FOR_VEHICLE_TRACKING';
export const RESET_POD_ATTACHMENTS_FOR_VEHICLE_TRACKING =
  'RESET_POD_ATTACHMENTS_FOR_VEHICLE_TRACKING';

// Product
export const GET_LIST_FOR_PRODUCT = 'GET_LIST_FOR_PRODUCT';

export const GET_PLANTS = 'GET_PLANTS';

export const GET_UNIT_OF_MEASUREMENTS = 'GET_UNIT_OF_MEASUREMENTS';
export const GET_QUALITY_CHECK_VEHICLE_TRACKING_LIST =
  'GET_QUALITY_CHECK_VEHICLE_TRACKING_LIST';
export const GET_VEHICLE_TRACKING_LINE_ITEM_QUALITY_CHECK_LOG =
  'GET_VEHICLE_TRACKING_LINE_ITEM_QUALITY_CHECK_LOG';
export const GET_DIMENSION_FOR_QUALITY_CHECK_CREATE_LOG =
  'GET_DIMENSION_FOR_QUALITY_CHECK_CREATE_LOG';
export const CREATE_VEHICLE_TRACKING_LINE_ITEM_QUALITY_CHECK_LOG =
  'CREATE_VEHICLE_TRACKING_LINE_ITEM_QUALITY_CHECK_LOG';
export const GET_LOG_FOR_QUALITY_CHECKS = 'GET_LOG_FOR_QUALITY_CHECKS';
export const GET_AVAILABLE_QUALITY_CHECKS_FOR_VEHICLE_TRACKING =
  'GET_AVAILABLE_QUALITY_CHECKS_FOR_VEHICLE_TRACKING';
export const CREATE_VEHICLE_TRACKING_LINE_ITEM_REJECTION_LOG =
  'CREATE_VEHICLE_TRACKING_LINE_ITEM_REJECTION_LOG';
export const GET_VEHICLE_TRACKING_LINE_ITEM_REJECTION_LOGS =
  'GET_VEHICLE_TRACKING_LINE_ITEM_REJECTION_LOGS';

// Breadcrumb

export const PUSH_BREADCRUMB_ITEM = 'PUSH_BREADCRUMB_ITEM';
export const POP_BREADCRUMB_ITEM = 'POP_BREADCRUMB_ITEM';
export const RESET_BREADCRUMB = 'RESET_BREADCRUMB';

export const GET_VEHICLE_TRACKING_DASHBOARD_DATA =
  'GET_VEHICLE_TRACKING_DASHBOARD_DATA';
export const GET_TENANT_PERMISSION = 'GET_TENANT_PERMISSION';

export const GET_VEHICLE_TRACKING_CHANGE_LOG_LIST =
  'GET_VEHICLE_TRACKING_CHANGE_LOG_LIST';

export const GET_VEHICLE_TRACKING_CHANGE_LOGS =
  'GET_VEHICLE_TRACKING_CHANGE_LOGS';
export const GET_TENANT_FEATURE_FLAGS = 'GET_TENANT_FEATURE_FLAGS';

// Invoice Action Types
export const CREATE_VEHICLE_TRACKING_ATTACHMENT =
  'CREATE_VEHICLE_TRACKING_ATTACHMENT';
export const GET_PREFILL_SUGGESTIONS_FOR_VEHICLE_TRACKING_LINE_ITEMS =
  'GET_PREFILL_SUGGESTIONS_FOR_VEHICLE_TRACKING_LINE_ITEMS';
export const GET_VEHICLE_TRACKING_ATTACHMENTS =
  'GET_VEHICLE_TRACKING_ATTACHMENTS';
export const DELETE_VEHICLE_TRACKING_ATTACHMENT =
  'DELETE_VEHICLE_TRACKING_ATTACHMENT';

// Sync Action Types
export const TRIGGER_MANUAL_SYNC_EVENTS_FROM_SAP =
  'TRIGGER_MANUAL_SYNC_EVENTS_FROM_SAP';

export const GET_ASSIGNED_STAGES_FOR_WORKFLOW_ASSIGNED_TO_USER =
  'GET_ASSIGNED_STAGES_FOR_WORKFLOW_ASSIGNED_TO_USER';
export const GET_ASSIGNED_PLANT_FOR_EMPLOYEE =
  'GET_ASSIGNED_PLANT_FOR_EMPLOYEE';
export const GET_OUTWARD_REPORT = 'GET_OUTWARD_REPORT';
export const GET_ATTACHED_DELIVERIES_FOR_VEHICLE_TRACKING =
  'GET_ATTACHED_DELIVERIES_FOR_VEHICLE_TRACKING';
export const GET_ATTACHED_DELIVERY_LINE_ITEMS_FOR_VEHICLE_TRACKING =
  'GET_ATTACHED_DELIVERY_LINE_ITEMS_FOR_VEHICLE_TRACKING';
export const UPDATE_VEHICLE_TRACKING_DELIVERY_ATTACHMENTS =
  'UPDATE_VEHICLE_TRACKING_DELIVERY_ATTACHMENTS';
export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_OUTWARD_REPORT_WITH_EXIT_TIME =
  'GET_OUTWARD_REPORT_WITH_EXIT_TIME';
export const RESET_TIMELINE = 'RESET_TIMELINE';
export const UPDATE_VEHICLE_TRACKING_DETAILS =
  'UPDATE_VEHICLE_TRACKING_DETAILS';
export const GET_TRANSPORTER_LIST = 'GET_TRANSPORTER_LIST';
export const GET_VARIANCE_REPORT_FOR_OUTWARD =
  'GET_VARIANCE_REPORT_FOR_OUTWARD';
export const UPDATE_PROFILE_DETAILS = 'UPDATE_PROFILE_DETAILS';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const SET_PROFILE_IMAGE = 'SET_PROFILE_IMAGE';
export const UPDATE_VEHICLE_TRACKING_STATUS = 'UPDATE_VEHICLE_TRACKING_STATUS';
export const GET_REASONS_DROPDOWN_OPTIONS_FOR_VEHICLE_TRACKING =
  'GET_REASONS_DROPDOWN_OPTIONS_FOR_VEHICLE_TRACKINGs';
export const GET_TENANT_LOGO_URL = 'GET_TENANT_LOGO_URL';
export const GET_VEHICLE_TRACKING_COMMENTS = 'GET_VEHICLE_TRACKING_COMMENTS';
export const GET_PROFILES = 'GET_PROFILES';
export const CREATE_COMMENT_FOR_VEHICLE_TRACKING =
  'CREATE_COMMENT_FOR_VEHICLE_TRACKING';
export const UPLOAD_VEHICLE_TRACKING_ATTACHMENTS =
  'UPLOAD_VEHICLE_TRACKING_ATTACHMENTS';
export const GET_DOCUMENT_LIST_FOR_VEHICLE_TRACKING =
  'GET_DOCUMENT_LIST_FOR_VEHICLE_TRACKING';
